<div id="custom-overlay">
  <div class="help">
    <ion-fab-button size="small" color="light" fill="solid" class="close" (click)="help()">
      <ion-icon name="help"></ion-icon>
    </ion-fab-button>
  </div>
</div>
<ion-content fullscreen="true"></ion-content>

<div class="bottom" [hidden]="!show">
  <ion-item hidden>
    <ion-label>Campus</ion-label>
    <ion-select placeholder="Seleccionar" #mySelect (ionChange)="goPreregister(mySelect.value)">
      <ion-select-option value="3">CCM</ion-select-option>
      <ion-select-option value="5">CEM</ion-select-option>
      <ion-select-option value="6">CEM - Esmeralda</ion-select-option>
      <ion-select-option value="11">Guadalajara</ion-select-option>
      <ion-select-option value="9">Querétaro</ion-select-option>
      <ion-select-option value="10">Santa Fe</ion-select-option>
    </ion-select>
  </ion-item>
  <ion-grid>
    <ion-row class="option-sign">
      <ion-col>
        <ion-button shape="round" color="light" (click)="preregister()" *ngIf="(mitec$ | async) === false">
          REGISTRARME
        </ion-button>
        <br />
        <br />
        <ion-button shape="round" fill="outline" color="light" [routerLink]="['/login']">INICIAR SESIÓN</ion-button>
        <br />
        <br />
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
